import { compact } from 'lodash';

export default class {
  attributes: {
    zone?: string;
    make?: string;
    model?: string;
  };

  constructor(attributes = {}) {
    this.attributes = attributes;
  }

  get networkId(): string {
    return '/19485787';
  }

  get site(): string {
    return '/AutoList.com';
  }

  toString(): string {
    const { zone, make, model } = this.attributes;
    return compact([`${this.networkId}${this.site}`, zone, make, model]).join('/');
  }
}
